class CopyDiscountCode extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-discount-code');
    this.template = this.querySelector('template');
    this.wrapper = this;

    this.button?.addEventListener('click', () => this.copyCode());
  }

  copyCode() {
    const codeText = this.querySelector('[data-coupon-text]')?.innerText;

    if (!codeText) return;

    // Attempt clipboard API; fallback for Shopify Editor
    this.safeCopy(codeText).then(() => {
      this.showMessage();
    });
  }

  async safeCopy(text) {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
      } else {
        this.fallbackCopy(text);
      }
    } catch (e) {
      this.fallbackCopy(text);
    }
  }

  fallbackCopy(text) {
    const area = document.createElement("textarea");
    area.value = text;
    area.style.position = "fixed";
    area.style.opacity = "0";
    document.body.appendChild(area);
    area.select();
    document.execCommand("copy");
    document.body.removeChild(area);
  }

  showMessage() {
    // remove existing
    const oldMsg = this.wrapper.querySelector('[copy-code-tooltip]');
    if (oldMsg) oldMsg.remove();

    // append new
    const cloned = this.template.content.cloneNode(true);
    console.log('cloned', cloned);
    this.wrapper.appendChild(cloned);

    const successElement = this.wrapper.querySelector('[copy-code-tooltip]');

    // auto-remove
    setTimeout(() => {
      successElement?.remove();
    }, 3000);
  }
}

customElements.define('copy-discount', CopyDiscountCode);
